import { render, staticRenderFns } from "./TotalOrdersLast30Days.vue?vue&type=template&id=69ad0ff2&scoped=true&"
import script from "./TotalOrdersLast30Days.vue?vue&type=script&lang=js&"
export * from "./TotalOrdersLast30Days.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad0ff2",
  null
  
)

export default component.exports